import { useLang } from '@/i18n';
import EfNavProduct, { EfNavProductItemProps } from '@elem/ui/ef-nav-product';
import { useRouter } from 'next/router';
import { useProductDispatch, useProductStore } from '../../ProductProvider';
import GetProductData from '../GetProductData';

export default function NavProduct({ generalKey }: { generalKey: string }) {
    const { productPageData } = useProductStore();
    const { locale } = useRouter();
    const { t } = useLang('theProduct.NavProduct');
    const dispatch = useProductDispatch();
    const list: EfNavProductItemProps[] = [
        {
            type: 'Product',
            title: t('Product'),
        },
        {
            type: 'Support',
            title: t('Support'),
        },
        {
            type: 'Specs',
            title: t('Specs'),
        },
    ];
    const buyItem = {
        type: 'BuyNow',
        title: t('BuyNow'),
        href: productPageData.productDetail?.buyLink,
    };

    const itemCallback = (item: any) => {
        dispatch({
            type: 'changeProductTabActive',
            payload: item.type,
        });
        // 切换时划回顶部
        setTimeout(() => {
            const headerElem = document.querySelector('.ecoflow-frame-header');
            window.scrollTo({
                top: headerElem?.clientHeight,
                behavior: 'smooth', // 可选，平滑滚动
            });
        }, 100);
    };

    return (
        <>
            <GetProductData generalKey={generalKey} />
            <EfNavProduct selectType="Product" name={t('name')} list={list} buyItem={buyItem} callback={itemCallback} locale={locale}></EfNavProduct>
        </>
    );
}
